import './App.scss';
import './reset.css';

import { RosterContext, SettingsContext } from './context/context';
import { initialState, reducer } from './context/state';
import { useEffect, useReducer, useState } from 'react';

import Header from './components/header/header';
import { Helmet } from 'react-helmet';
import Reference from './components/reference/reference';
import Team from './components/team/team';

function App() {
  const [state, dispatch] = useReducer(reducer, initialState);
  const [roster, setRoster] = useState({ units: [] });

  useEffect(() => {
    const height = document.getElementById('aheader').getBoundingClientRect().height + 20;
    document.getElementsByClassName('padding')[0].style.marginTop = `${height}px`;
  });

  return (
    <RosterContext.Provider value={{ roster, setRoster }}>
    <SettingsContext.Provider value={{
      state, dispatch
    }}>
    <Helmet>
      <title>KT Card Generator</title>
      <body className={`${state.paperSize} ${state.pageOrientation} ${state.treeKiller ? 'tree-killer' : ''} ${state.cardOrientation}`} />
    </Helmet>

    <Header />
    <div className="padding"></div>
    <div className="content">
      {state.sections.length <=0 ?
        (<h1 className="upload-message"> Upload yo BattleScribe KillTeam roster file</h1>)
        : null}
      <Team/>
      <Reference roster={roster} />
    </div>

    </SettingsContext.Provider>
    </RosterContext.Provider>
  );
}

export default App;
